import { FC, useState } from 'react';
import { useQuery } from 'react-query';
import useGeneralError from 'src/hooks/useGeneralError';
import { useTranslation } from 'src/components/dashboard/initialPopups/i18n';
import { useAuth } from 'src/contexts/JWTContext';
import { DialogContent } from 'material-hu';
import HTMLBody from 'src/components/HTMLBody';
import AcceptCancelDialog from 'src/components/AcceptCancelDialog';
import {
  getNewFeatures,
} from 'src/services/authService';
import { initialPopupKeys } from 'src/components/dashboard/initialPopups/queries';

const NewFeatures: FC = () => {
  const [open, setOpen] = useState(true);

  const { t } = useTranslation();
  const showGeneralError = useGeneralError();
  const { user } = useAuth();

  const dataFatures = useQuery(
    initialPopupKeys.features(),
    () => getNewFeatures(),
    {
      onError: (err) =>
        showGeneralError(err, t('ERROR_GET_NEW_FEATURES')),
      enabled: user?.lastTermsAndConditionsAccepted,
    },
  );

  const newFeatures = dataFatures?.data?.data || undefined;

  const handleAccept = () => {
    setOpen(false);
  };

  const shouldOpenDialog = open && !!newFeatures && !newFeatures?.seen;

  return (
    <AcceptCancelDialog
      open={shouldOpenDialog}
      onAccept={handleAccept}
      enabledTitle={false}
    >
      <DialogContent
        dividers
        sx={{ borderTop: '0' }}
      >
        <HTMLBody body={newFeatures?.body} />
      </DialogContent>
    </AcceptCancelDialog>
  );
};

export default NewFeatures;
